export default __webpack_public_path__ + "static/media/amex.92ebcb59.png";